import axios from "axios";
import SessionId from "../../Utils/SessionId";
import uuid from "uuid";
import {changeOrdersStatusUI} from "./ordersActions";
import {updateMessengerAvailabilityUIAction} from "./messengersActions";

export function fetchAssignedDeliveryGroupsAction(bid) {
    return {
        type: "FETCH_ASSIGNED_DELIVERY_GROUPS",
        payload: async () => {
            const response = await axios.get('/api/v2a/getAssignedDeliveryGroups', {
                params: {bid}
            });

            return response.data;
        }
    };
}

export function fetchLockedDeliveryGroupsAction(bid) {
    return {
        type: "FETCH_LOCKED_DELIVERY_GROUPS",
        payload: async () => {
            const response = await axios.get('/api/v2a/getLockedGroups', {
                params: {bid}
            });

            return response.data;
        }
    };
}

export function evaluateDeliveryGroupsAction(bid, groupings, isSpecific = false) {
    const requestId = uuid.v4();

    return {
        type: "EVALUATE_DELIVERY_GROUPS",
        meta: {
            bid: bid,
            requestId: requestId,
            isSpecific: isSpecific
        },
        payload: async () => {
            const requestBody = {
                bid: bid,
                sessionId: SessionId.getId(),
                requestId: requestId
            };

            if (groupings)
                requestBody.groupings = groupings;

            const deliveryGroupsResp = await axios.post('/api/v2a/evaluateDeliveryGroups', requestBody);

            return deliveryGroupsResp.data
        }
    };
}

export function sendDeliveryGroupAction(group) {
    return async (dispatch) => {
        await dispatch({
            type: "SEND_DELIVERY_GROUP",
            meta: group,
            payload: async () => {
                const response = await axios.post('/api/v2a/sendGroup', group);

                return response.data;
            }
        });

        dispatch(updateMessengerAvailabilityUIAction(
            group.bid,
            group.messenger_id,
            false,
            true
        ));

        dispatch(changeOrdersStatusUI(group.route.map(stop => stop.order_id), "ASSIGNED"));
    };
}

export function editDeliveryGroupAction(group, changes) {
    return async (dispatch) => {
        await dispatch({
            type: "EDIT_DELIVERY_GROUP",
            meta: group,
            payload: async () => {
                const response = await axios.post('/api/v2a/editGroup',
                    {
                        group: group,
                        changes: changes
                    }
                );

                return response.data;
            }
        });

        dispatch(updateMessengerAvailabilityUIAction(
            group.bid,
            group.messenger_id,
            false,
            true
        ));

        dispatch(changeOrdersStatusUI(group.route.map(stop => stop.order_id), "ASSIGNED"));
    };
}

export function cancelDeliveryGroupAction(bid, deliveryGroupId) {
    return async (dispatch, getState) => {
        const ordersIds = getOrdersByDeliveryGroup(getState().deliveryGroupsReducer.assignedDeliveryGroups, deliveryGroupId);
        await dispatch(cancelDeliveryGroup(bid, deliveryGroupId));
        dispatch(changeOrdersStatusUI(ordersIds, "READY"));
    }
}

export function cancelDeliveryGroupOrdersAction(bid, deliveryGroupId, ordersIds) {
    return async (dispatch, getState) => {
        if (!ordersIds)
            ordersIds = getOrdersByDeliveryGroup(getState().deliveryGroupsReducer.assignedDeliveryGroups, deliveryGroupId);

        await dispatch(cancelDeliveryGroupOrders(bid, deliveryGroupId, ordersIds));
        dispatch(changeOrdersStatusUI(ordersIds, "READY"));
    }
}

export function cancelDeliveryGroup(bid, deliveryGroupId) {
    return {
        type: "CANCEL_DELIVERY_GROUP",
        meta: {deliveryGroupId},
        payload: async () => {
            const response = await axios.post('/api/v2a/cancelDeliveryGroup', {
                bid: bid,
                deliveryGroupId: deliveryGroupId
            });

            return response.data;
        }
    };
}

export function cancelDeliveryGroupOrders(bid, deliveryGroupId, ordersIds) {
    return {
        type: "CANCEL_DELIVERY_GROUP_ORDERS",
        meta: {deliveryGroupId, ordersIds},
        payload: async () => {
            const response = await axios.post('/api/v2a/' +
                'cancelDeliveryGroupOrders', {
                bid: bid,
                deliveryGroupId: deliveryGroupId,
                ordersIds: ordersIds
            });

            return response.data;
        }
    };
}

export function lockDeliveryGroup(group) {
    return {
        type: "LOCK_DELIVERY_GROUP",
        meta: group,
        payload: async () => {
            const response = await axios.post('/api/v2a/lockGroup', group);

            return response.data;
        }
    };
}

export function unlockDeliveryGroup(group) {
    return {
        type: "UNLOCK_DELIVERY_GROUP",
        meta: group,
        payload: async () => {
            const response = await axios.post('/api/v2a/unlockGroup', group);

            return response.data;
        }
    };
}

export function lockMessengerToGroup(group) {
    return {
        type: "LOCK_MESSENGER_TO_GROUP",
        meta: group,
        payload: async () => {
            const response = await axios.post('/api/v2a/lockMessengerToGroup', group);

            return response.data;
        }
    };
}

export function unlockMessengerFromGroup(group) {
    return {
        type: "UNLOCK_MESSENGER_FROM_GROUP",
        meta: group,
        payload: async () => {
            const response = await axios.post('/api/v2a/unlockMessengerFromGroup', group);

            return response.data;
        }
    };
}


export function addOrdersToLockedGroup(addToGroup) {
    return {
        type: "ADD_ORDERS_TO_LOCKED_DELIVERY_GROUP",
        meta: addToGroup,
        payload: async () => {
            const response = await axios.post('/api/v2a/addOrdersToLockedGroup', addToGroup);

            return response.data;
        }
    };
}

export function removeOrdersFromLockedGroup(removeFromGroup) {
    return {
        type: "REMOVE_ORDERS_FROM_LOCKED_DELIVERY_GROUP",
        meta: removeFromGroup,
        payload: async () => {
            const response = await axios.post('/api/v2a/removeOrdersFromLockedGroup', removeFromGroup);

            return response.data;
        }
    };
}

function getOrdersByDeliveryGroup(deliveryGroups, deliveryGroupId) {
    const deliveryGroup = deliveryGroups.find(deliveryGroup => deliveryGroup.id === deliveryGroupId);

    if (!deliveryGroup)
        return null;

    return deliveryGroup.route.map(deliveryOrder => deliveryOrder.order_id);
}

export function finishDeliveryGroupAction(bid, groupId) {
    return async (dispatch, getState) => {
        const ordersIds = getOrdersByDeliveryGroup(getState().deliveryGroupsReducer.assignedDeliveryGroups, groupId);

        await dispatch({
            type: 'FINISH_DELIVERY_DELIVERY_GROUP',
            meta: {
                bid: bid,
                groupId: groupId
            },
            payload: async () => {
                let {data: result} = await axios.post('api/v2a/finishDeliveryGroup', {
                    bid: bid,
                    groupId: groupId
                });

                return result.success;
            }
        });

        if (ordersIds)
            dispatch(changeOrdersStatusUI(ordersIds, "DELIVERED"));
    };
}